import { render } from "./ListDriversPage.vue?vue&type=template&id=594cec4c&scoped=true&ts=true"
import script from "./ListDriversPage.vue?vue&type=script&lang=ts"
export * from "./ListDriversPage.vue?vue&type=script&lang=ts"

import "./ListDriversPage.vue?vue&type=style&index=0&id=594cec4c&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-594cec4c"]])

export default __exports__